export const combineUrlAndQueryParams = ({ url = '', paramsObject = {} }) => {
  let params = {}

  if (typeof paramsObject === 'object' && paramsObject !== null) {
    params = {...paramsObject}
  }

  if (params.hasOwnProperty('q')) {
    delete params['q']
  }

  const queryParamsString = new URLSearchParams(params).toString()

  if (queryParamsString !== '') {
    return `${url}?${queryParamsString}`
  }

  return url
}
